import t from "react";
const o = t.createContext({
  itemRef: () => {
  }
});
export {
  o as FormContext
};
//# sourceMappingURL=ReoFormCompContext.mjs.map
